'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getCalendarDaySettings = {};

exports.__exports = getCalendarDaySettings;
